import { BaseModel } from "sjs-base-model";
import ContentModel from "./ContentModel";

export default class DocumentsDownloadActionModel extends BaseModel {
    public readonly content: ContentModel = new ContentModel({});
    public readonly name: string = "";
    public readonly contentType: string = "";

    constructor(data: Partial<DocumentsDownloadActionModel>) {
        super();

        this.update(data);
    }
}
